/**
 * @author Shivam Kapoor (shivamk2021@email.iimcal.ac.in)
 */

import React from 'react';
import { GoogleLogin, GoogleLogout } from 'react-google-login';
import Firebase from "./firebase";
import { Button, Divider, message, Popconfirm, Table } from 'antd';
import { QuestionCircleOutlined } from '@ant-design/icons';
import AddSlotModal from './AddSlotModal';
import Download from './jsontocsv';
import admins from './admins';
import logo from './basic.jpg';
import iimcLogo from './iim-cal-logo.png'
import './App.css';

class App extends React.Component {
  constructor(props) {
    super(props);
    this.columns = [
      {
        title: '#',
        dataIndex: 'index',
        key: 'index',
        align: 'center',
        width: 50,
        sorter: {
          compare: (a, b) => a.index - b.index,
        }
        // fixed: 'left'
      },
      {
        title: 'Slot Name',
        dataIndex: 'slotName',
        key: 'slotName',
        sorter: {
          compare: (a, b) => a.slotName - b.slotName,
        }
        // fixed: 'left'
      },
      {
        title: 'Current',
        dataIndex: 'current',
        key: 'current',
        width: 100,
        sorter: {
          compare: (a, b) => a.current - b.current,
        }
      },
      {
        title: 'Max Limit',
        dataIndex: 'limit',
        key: 'limit',
        width: 100,
        sorter: {
          compare: (a, b) => a.limit - b.limit,
        }
      }
    ];
    this.state = {
      isSignedIn: false,
      showAddSlotModal: false,
      isAdmin: false,
      dataSource: [],
      newSlot: {
        slotName: "",
        current: 0,
        limit: 10000
      },
    };
    this.onSignIn = this.onSignIn.bind(this);
    this.onFailure = this.onFailure.bind(this);
    this.onLogout = this.onLogout.bind(this);
    this.addSlot = this.addSlot.bind(this);
    this.handleDelete = this.handleDelete.bind(this);
    this.setVisible = this.setVisible.bind(this);
    this.bookSlot = this.bookSlot.bind(this);
    this.hasBooked = this.hasBooked.bind(this);
  }
  componentDidMount() {
    console.log("state: ", this.state);
    Firebase.database().ref("/dataSource").on('value', snapshot => {
      if (snapshot.val()) {
        this.setState({ dataSource: snapshot.val() })
      }
    });
  }
  onSignIn(response) {
    let googleUser = response.profileObj;
    let isAdmin = admins.find(user => user === googleUser.email) ? true : false;
    if (isAdmin) {
      this.columns.push({
        //   title: 'Download',
        //   dataIndex: 'download',
        //   key: 'download',
        //   width: 100,
        //   align: 'center',
        //   fixed: 'right',
        //   render: (text, record) => (
        //     <div><svg style={{ color: "#975600" }} onClick={() => Download(record.currentList, record.slotName)} disabled={record.currentList ? false : true} width="1em" height="1em" viewBox="0 0 16 16" class="bi bi-download" fill="currentColor" xmlns="http://www.w3.org/2000/svg">
        //       <path fill-rule="evenodd" d="M.5 9.9a.5.5 0 0 1 .5.5v2.5a1 1 0 0 0 1 1h12a1 1 0 0 0 1-1v-2.5a.5.5 0 0 1 1 0v2.5a2 2 0 0 1-2 2H2a2 2 0 0 1-2-2v-2.5a.5.5 0 0 1 .5-.5z" />
        //       <path fill-rule="evenodd" d="M7.646 11.854a.5.5 0 0 0 .708 0l3-3a.5.5 0 0 0-.708-.708L8.5 10.293V1.5a.5.5 0 0 0-1 0v8.793L5.354 8.146a.5.5 0 1 0-.708.708l3 3z" />
        //     </svg></div>
        //   )
        // },
        //   {
        title: 'Actions',
        dataIndex: 'actions',
        key: 'actions',
        width: 90,
        align: 'center',
        fixed: 'right',
        render: (text, record) => (
          <div>
            <svg className="download bi bi-download" onClick={() => record.currentList ? Download(record.currentList, record.slotName) : message.info("can't download as no one booked the slot")} disabled={record.currentList ? false : true} width="1em" height="1em" viewBox="0 0 16 16" fill="currentColor" xmlns="http://www.w3.org/2000/svg">
              <path fill-rule="evenodd" d="M.5 9.9a.5.5 0 0 1 .5.5v2.5a1 1 0 0 0 1 1h12a1 1 0 0 0 1-1v-2.5a.5.5 0 0 1 1 0v2.5a2 2 0 0 1-2 2H2a2 2 0 0 1-2-2v-2.5a.5.5 0 0 1 .5-.5z" />
              <path fill-rule="evenodd" d="M7.646 11.854a.5.5 0 0 0 .708 0l3-3a.5.5 0 0 0-.708-.708L8.5 10.293V1.5a.5.5 0 0 0-1 0v8.793L5.354 8.146a.5.5 0 1 0-.708.708l3 3z" />
            </svg>
            <Divider type="vertical" />
            <Popconfirm title="Sure to delete?" onConfirm={() => this.handleDelete(record)} icon={<QuestionCircleOutlined style={{ color: 'red' }} />}>
              <svg style={{ color: "#a52a2a" }} width="1em" height="1em" viewBox="0 0 16 16" class="bi bi-trash-fill" fill="currentColor" xmlns="http://www.w3.org/2000/svg">
                <path fill-rule="evenodd" d="M2.5 1a1 1 0 0 0-1 1v1a1 1 0 0 0 1 1H3v9a2 2 0 0 0 2 2h6a2 2 0 0 0 2-2V4h.5a1 1 0 0 0 1-1V2a1 1 0 0 0-1-1H10a1 1 0 0 0-1-1H7a1 1 0 0 0-1 1H2.5zm3 4a.5.5 0 0 1 .5.5v7a.5.5 0 0 1-1 0v-7a.5.5 0 0 1 .5-.5zM8 5a.5.5 0 0 1 .5.5v7a.5.5 0 0 1-1 0v-7A.5.5 0 0 1 8 5zm3 .5a.5.5 0 0 0-1 0v7a.5.5 0 0 0 1 0v-7z" />
              </svg>
            </Popconfirm>
          </div>
        )
      });
    } else {
      this.columns.push({
        title: 'Book',
        dataIndex: 'bookSlot',
        key: 'bookSlot',
        width: 100,
        align: 'center',
        fixed: 'right',
        render: (text, record) => (
          <Popconfirm title="Are you Sure? Once booked you can't cancel later." disabled={this.hasBooked(record) || record.current >= record.limit} onConfirm={() => this.bookSlot(record)}>
            <Button className="book-slot" disabled={this.hasBooked(record) || record.current >= record.limit}> {this.hasBooked(record)? 'Booked': 'Book'} </Button>
          </Popconfirm>
        )
      });
    }
    this.setState({ isSignedIn: true, name: googleUser.name, url: googleUser.imageUrl, email: googleUser.email, isAdmin })
  }
  onFailure(e) {
    console.log('on failure', e);
    this.setState({ messageColor: 'red', message: e });
  }
  onLogout(googleUser) {
    console.log('user ' + googleUser)
    let columns = [];
    this.columns.forEach(item => {
      if (item.key === "actions" || item.key === "download" || item.key === "bookSlot") {
        return;
      }
      return columns.push(item);
    })
    this.columns = columns;
    this.setState({ isSignedIn: false, name: null, url: null, email: null })
  }
  addSlot(data) {
    let newSlot = {
      index: this.state.dataSource.length + 1,
      limit: data.limit,
      slotName: data.slotName,
      current: 0
    }
    const newData = [...this.state.dataSource];
    newData.push(newSlot);
    Firebase.database().ref("/dataSource").set(newData);
    this.setState({
      showAddSlotModal: false,
      dataSource: newData
    });
    message.success(`${data.slotName} Added Successfully`);
  }
  bookSlot(row) {
    let dataSource = [...this.state.dataSource];
    // eslint-disable-next-line array-callback-return
    dataSource.map(obj => {
      if (obj.index === row.index) {
        var user = {
          name: this.state.name,
          email: this.state.email
        }
        if (obj.currentList) {
          if (obj.currentList.length < obj.limit) {
            obj.currentList.push(user)
          } else {
            message.fail(`${row.slotName} Limit Reached`)
          }
        } else {
          obj.currentList = [user];
        }
        obj.current = obj.currentList.length
        return obj;
      }
    })
    this.setState({ dataSource });
    Firebase.database().ref("/dataSource").set(dataSource);
    message.success(`${row.slotName} Booked Successfully`);
  }
  hasBooked(row) {
    if (row.currentList) {
      return row.currentList.find(item => item ? item.name === this.state.name : null) ? true : false;
    }
    return false;
  }
  setVisible(bool) {
    this.setState({ showAddSlotModal: bool });
  }
  handleDelete(row) {
    let dataSource = [];
    dataSource = this.state.dataSource.filter(item => item.index !== row.index);
    dataSource.forEach((item, i) => {
      item.index = i + 1;
    })
    Firebase.database().ref("/dataSource").set(dataSource);
    this.setState({ dataSource });
    message.success(`${row.slotName} Deleted Successfully`);
  }
  render() {
    const { dataSource } = this.state;
    return (
      <div className="App">
        <div className="nav">
          <div className="container-fluid">
            <div className="row align-items-center">
              <div className="col-6">
                <div className="user align-items-center">
                  <img className="user-img" src={this.state.url ? this.state.url : logo} alt="profile" />
                  <div className="user-name">{this.state.name}</div>
                </div>
              </div>
              <div className="col-6 google">
                {!this.state.isSignedIn ?
                  <GoogleLogin
                    clientId="745796835906-iihbmr9f22kd2fmd08h050tbguitbclg.apps.googleusercontent.com"
                    // clientId="745796835906-hdocl4n9lb4mdu19o559nrg0phajgmu0.apps.googleusercontent.com" //localhost
                    buttonText="Sign In"
                    onSuccess={this.onSignIn}
                    onFailure={this.onFailure}
                    isSignedIn={true}></GoogleLogin>
                  :
                  <GoogleLogout
                    clientId="745796835906-iihbmr9f22kd2fmd08h050tbguitbclg.apps.googleusercontent.com"
                    // clientId="745796835906-hdocl4n9lb4mdu19o559nrg0phajgmu0.apps.googleusercontent.com" //localhost
                    buttonText="Logout"
                    onLogoutSuccess={this.onLogout}
                  ></GoogleLogout>
                }
              </div>
              <div className="col-12">
                <div className="app-name">Slot Booking Portal</div>
              </div>
            </div>
          </div>
        </div>
        {this.state.isSignedIn ? <div className="slot-table">
          {this.state.isAdmin ? <button className="new-slot" onClick={() => this.setState({ showAddSlotModal: true })}> New Slot </button> : null}
          <Table
            // components={components}
            // rowClassName={() => 'editable-row'}
            bordered
            scroll={{ x: 650 }}
            dataSource={dataSource}
            columns={this.columns}
            // pagination={{ pageSize: 5 }}
            pagination={{ 
              defaultPageSize: 5,
              showSizeChanger: true,
              pageSizeOptions: ["5","10","20"]}} 
          />
        </div>
          :
          <img src={iimcLogo} alt="IIMC" className="logged-out" />
        }
        <AddSlotModal
          visible={this.state.showAddSlotModal}
          setVisible={this.setVisible}
          onCreate={this.addSlot}
          onCancel={() => this.setVisible(false)} />
        <div id="footer" className="footer">
          <a id="jasig" href="http://student.iimcal.ac.in/dokuwiki/doku.php/isg/isg" alt="go to ISG home page"></a>
          <div id="copyright">
            <p>Copyright © 2020 ISG. All rights reserved.</p>
            <p>Powered by <a href="http://student.iimcal.ac.in/dokuwiki/doku.php/isg/isg" rel="noreferrer" target="_blank">Internet Solutions Group of IIM Calcutta</a></p>
            <p>Developed by <a href="http://student.iimcal.ac.in/jd/viewprofile.php?cn=shivamk2021" rel="noreferrer" target="_blank">Shivam Kapoor</a></p>
          </div>
        </div>
      </div>
    )
  }
}

export default App;